import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FileUpload } from 'src/app/model/file-upload.model';
import { FileUploadService } from 'src/app/services/file-upload-audit.service';
import Swal from 'sweetalert2';
import { BrdsqlService } from '../../services/brdsql.service';
declare var $: any; 

@Component({
  selector: 'app-audit-list',
  templateUrl: './audit-list.component.html',
  styleUrls: ['./audit-list.component.css']
})
export class AuditListComponent implements OnInit {

  auditdata?: any = [];
  yearID: any;
  supzone? = '';
  supcode? = '';
  cpbyone?: any=[];
  @ViewChild('tb_data') tb_data!: ElementRef;
  @ViewChild('frm_upaudit') frm_upaudit : NgForm;
  selectedFiles?: FileList;
  currentFileUpload?: FileUpload;
  percentage = 0;
  urlImg = "";
  selectAuditor = "";
  auditorPic = "";
  managerPic = "";
  setZero = 0;

  constructor(
    private brdservice: BrdsqlService,
    private uploadService: FileUploadService) 
    { 
    this.supzone = localStorage.getItem('supzone');
    this.yearID = brdservice.yearID;
  }

  ngOnInit(): void {
  }

  // ข้อมูลออดิตตามรหัสผู้ login
  getAuditData(f:any): void {
    localStorage.setItem('yearid' ,f.syearid);
    let yearid = localStorage.getItem('yearid');
    this.brdservice.getAuditData(yearid, this.supzone)
      .subscribe({
        next: (data: any) => {
          this.auditdata = data.recordset;
          // console.log('audit data :' ,this.auditdata);
          setTimeout(() => {
            $(this.tb_data.nativeElement).DataTable();
          }, 0);
        },
        error: (e) => console.error(e)
      });
  };

  modalUpdataaudit(dataid:any) {
    this.cpbyone = [];
    $("#explan_plant").modal('show');
    this.cpbyone = this.auditdata.filter((el: { DataId: any; }) => el.DataId == dataid);
    // console.log('cpbyone: ',this.cpbyone);
  };

  modalShowPic(dataid:any) {
    this.cpbyone = [];
    $("#md_showpic").modal('show');
    this.cpbyone = this.auditdata.filter((el: { DataId: any; }) => el.DataId == dataid);
    // console.log('cpbyone: ',this.cpbyone);
  };

  // บันทึก ความเห็นผู้จัดการโซน
  saveUpdateaudit(f:any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.updateAudit(f)
        .subscribe({
          next: (data:any) => {
            // console.log('message from api: ',data);
            if(data.rowsAffected == 1) {
              Swal.fire('บันทึกข้อมูลสำเร็จ!','success')
              // let syearid: any = localStorage.getItem('yearid');
              this.resetFormAudit();
            } else {
              Swal.fire({icon: 'error',title: 'Oops...',text: 'บันทึกข้อมูลไม่สำเร็จ!',footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>'})
            }
          }
        });
        // console.log('form value: ',f)
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
      this.closemodel();
    })
  };

  closemodel(){
    $("#explan_plant").modal('hide');
  }

  // select file to upload from audit
  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
  }

  // upload photo from audit
  upload(): void {
    this.supcode = localStorage.getItem('supcode');
    // console.log('supcode upload method in audit list :' ,this.supcode);
    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);
      this.selectedFiles = undefined;
      if (file) {
        this.currentFileUpload = new FileUpload(file);
        this.uploadService.pushFileToStorage(this.currentFileUpload).subscribe(
          percentage => {
            this.percentage = Math.round(percentage ? percentage : 0);
            let bucket = 'brr-farmluck.appspot.com'
            let url_pubilc = 'https://storage.googleapis.com/'+ bucket +'/auditPic/'+ file.name;
            console.log(url_pubilc);
            this.urlImg = url_pubilc;
          },
          error => {
            console.log(error);
          }
        );
      }
    }
  } 
  
  resetFormAudit() {
    this.frm_upaudit.reset()
    // this.formEdit = false;
  }  
}
